import { render } from "./Opportunity.vue?vue&type=template&id=7a8f48b2"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
script.render = render

export default script